import { render, staticRenderFns } from "./AccountChangeDetail.vue?vue&type=template&id=def5b480&scoped=true"
import script from "./AccountChangeDetail.vue?vue&type=script&lang=js"
export * from "./AccountChangeDetail.vue?vue&type=script&lang=js"
import style0 from "./AccountChangeDetail.vue?vue&type=style&index=0&id=def5b480&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "def5b480",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('def5b480')) {
      api.createRecord('def5b480', component.options)
    } else {
      api.reload('def5b480', component.options)
    }
    module.hot.accept("./AccountChangeDetail.vue?vue&type=template&id=def5b480&scoped=true", function () {
      api.rerender('def5b480', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/member/components/AccountChangeDetail.vue"
export default component.exports